import * as Yup from "yup";
import messages from "../../../assets/locale/messages";

export const CHANGE_PASSWORD_SCHEMA = (lang) => {
  const {
    inputs: {
      passwordConfirmationRequired,
      passwordRequired,
      passwordMatch,
      oldPasswordRequired
    }
  } = messages[lang];

  return Yup.object().shape({
    old_password: Yup.string().required(oldPasswordRequired),
    password: Yup.string().required(passwordRequired),
    confirmNewPassword: Yup.string()
      .required(passwordConfirmationRequired)
      .oneOf([Yup.ref("password"), null], passwordMatch)
  });
};
